// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"314425bd","780":"90dde2c0","794":"ebd0a93b"}[chunkId] + ".chunk.js";
};